import request from '@/utils/request'

export function getForbiddenWord(streamer_id) {
  return request({
    url:`streamers/${streamer_id}/forbidden_word_list`,
    method: 'get',
  })
}
